import Collapsible from 'react-collapsible';
import Arrow from '../../images/arrow.png'

export function Faq() {
    return (
        <div className='card' id="faq">
            <h2>Perguntas Frequentes</h2>
            <div className="faq">
                <Collapsible  trigger={<div className='faq-item'>
                    <h3 className='question'>Como são as aulas?</h3>
                    <img src={Arrow} alt='ícone de mais' className='arrow-img'/>
                    </div>}>
                    <p>As aulas são focadas em ensinar e desenvolver as técnicas e habilidades relacionadas ao boxe.
                    Praticamos diariamente coordenação, footwork e técnicas defensivas sempre de forma dinâmica e supervisionada.</p>
                </Collapsible>
                <Collapsible trigger={<div className='faq-item'>
                    <h3 className='question'>Quanto custa?</h3>
                    <img src={Arrow} alt='ícone de mais' className='arrow-img'/>
                    </div>}>
                    <p>A mensalidade custa R$135,00 por mês, também aceitamos Gympass e Totalpass.
                    Faça uma aula experimental sem custos.</p>
                </Collapsible>
                <Collapsible trigger={<div className='faq-item'>
                    <h3 className='question'>O que preciso para fazer uma aula?</h3>
                    <img src={Arrow} alt='ícone de mais' className='arrow-img'/>
                    </div>}>
                    <p>Apenas vontade de aprender e roupa confortável para se exercitar. 
                    Há equipamentos higienizados a disposição para as primeiras aulas.</p>
                </Collapsible>
            </div>
        </div>
    );
}